import { EPromoInventoryActionType } from './types';
import { EBannerStatus } from '../../types/promoInventory';
import { actionGenerator } from '../../utils/redux/actionGenerator';

export const changeBannerStatus = actionGenerator<EPromoInventoryActionType.BannerStatusChanged, EBannerStatus>(
  EPromoInventoryActionType.BannerStatusChanged,
);
